// extracted by mini-css-extract-plugin
export default {"select":"select--406448","option--marked":"option--marked--afde68","optionMarked":"option--marked--afde68"};